import React, {useState} from "react";
import {useVehicleTrackerTypeData} from "../../../hooks/useVehicleTrackerTypeData";
import {useDispatch, useSelector} from "react-redux";
import {getDataFresh, getVehicleTrackerTypeData} from "../../../state/selectors";
import { Box, Pagination, Table, Title } from "@allxsmith/bestax-bulma";
import {VehicleTypeTrackerRow} from "./VehicleTypeTrackerRow";
import Spinner from "react-spinner-material";
import {NewVehicleTrackerType} from "./NewVehicleTrackerType";
import {createSetVehicleTrackerTypeDataAction} from "../../../actions/dataActions";
import PaginationWrapper from "../../Utils/PaginationWrapper";




export default function VehicleTrackerType(props){
    const dispatch = useDispatch();
    let dataFresh = useSelector(getDataFresh);
    const [page, setPage] = useState(1);

    let loading = useVehicleTrackerTypeData({page:page, page_size:25}, dataFresh);
    const data = useSelector(getVehicleTrackerTypeData);


    if (!loading) {
        return (
          <Box>
            <Spinner
              className="spinner-centre"
              size={120}
              spinnerColor={"#3273dc"}
              spinnerWidth={2}
            />
          </Box>
        );
    }

    const onVehicleTrackerTypeUpdate = (index, newVehicleTrackerType) => {
        let newResults = [...data.results];
        let newState = {...data, results: newResults};
        newState.results[index]=newVehicleTrackerType;
        dispatch(createSetVehicleTrackerTypeDataAction(newState));
    }

    // TODO(bestax-migrate): `showFirstLast` — no showFirstLast prop in bestax Pagination
    return (
        <div>
            <NewVehicleTrackerType dataFresh={dataFresh}/>
            <Box>
                <details>
                    <summary><Title>Vehicle Tracker Type</Title></summary>
                    <Title size="6">
                        Note: Modifying these values will update the tracker types of existing trackers!
                    </Title>
                    <Table
                        isFullwidth
                    >
                        <thead>
                        <tr>
                            <th>Name</th>
                            <th>Monthly Cost</th>
                            <th>UpFront Cost</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        {data.results.map((type, index) => (
                            <VehicleTypeTrackerRow
                                type={type}
                                dataFresh={dataFresh}
                                onVehicleTrackerTypeUpdate={onVehicleTrackerTypeUpdate}
                                index={index}
                            />
                        ))}
                        </tbody>
                    </Table>
                    <PaginationWrapper
                        setPage={setPage}
                        page={page}
                        dataCount={Math.ceil(data.count / 25)}
                    />
                </details>
            </Box>
        </div>
    );


}